import * as Yup from "yup";

// Valores iniciales para el formulario de registro
export function initialValues() {
  return {
    avatar: "", // Pregunta si hay un usuario y si lo hay toma el avatar, si no, usa un string vacío
    fileAvatar: null,
    firstname: "",
    lastname: "",
    country: "España",
    address: "",
    phone: "",
    role: "partner", // Valor por defecto 'partner' para Cuenta Partner
    email: "",
    password: "",
    repeatPassword: "",
    holded: "", // Campo opcional para Partner
    conditionsAccepted: false,
    code: "",
  };
}

// Esquema de validación con Yup
export function validationSchema(verificationSent, t) {
  return Yup.object({
    firstname: Yup.string().required(t("validation.nameRequired")),
    lastname: Yup.string().required(t("validation.lastNameRequired")),
    country: Yup.string().required(t("validation.countryRequired")),
    address: Yup.string(),
    phone: Yup.string().matches(/^\+?\d+$/, t("validation.phoneFormat")),
    role: Yup.string()
      .oneOf(["partner"], t("validation.roleInvalid"))
      .required(t("validation.roleRequired")),
    // Campo opcional para partner:
    holded: Yup.string(),
    email: Yup.string()
      .email(t("validation.emailInvalid"))
      .required(t("validation.required")),
    password: Yup.string()
      .min(8, t("validation.passwordMin"))
      .required(t("validation.passwordRequiredField")),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref("password")], t("validation.passwordsMatch"))
      .min(8, t("validation.passwordMin"))
      .required(t("validation.passwordRequiredField")),
    conditionsAccepted: Yup.bool()
      .oneOf([true], t("validation.termsRequired"))
      .required(t("validation.passwordRequiredField")),
    code: Yup.string().when("verificationSent", {
      is: true,
      then: Yup.string()
        .required(t("validation.codeRequired"))
        .matches(/^[0-9]{6}$/, t("validation.codeFormat")),
    }),
  });
}
